// Signierter Connect-Kontext (vom Backend ausgestellt, 2 h) überlebt Login/Registrierung/E-Mail-Bestätigung im selben Browser.
const KEY = "dimedial-connect-ctx";
const TTL_MS = 2 * 60 * 60 * 1000;
const isBrowser = typeof window !== "undefined";

export const saveConnectCtx = (ctx, meta = {}) => { if (isBrowser) window.localStorage.setItem(KEY, JSON.stringify({ ctx, ...meta, exp: Date.now() + TTL_MS })); };
export const loadConnectCtx = () => {
  if (!isBrowser) return null;
  try { const d = JSON.parse(window.localStorage.getItem(KEY) || "null"); if (!d?.ctx || d.exp < Date.now()) { window.localStorage.removeItem(KEY); return null; } return d; } catch { return null; }
};
export const clearConnectCtx = () => { if (isBrowser) window.localStorage.removeItem(KEY); };
export const CONNECT_PATH = "/kunden/connect";
/** Nur interne Pfade ohne Protokoll/Host (gegen offene Weiterleitungen). */
export const safeNext = (n) => (n && /^\/[a-z0-9\-/?=&%._#]*$/i.test(n) && !n.startsWith("//") ? n : null);
